import type { ConfigType } from '@plone/registry';
import '@fontsource-variable/archivo/standard.css';
import installSettings from './config/settings';
import installViews from './config/views';
import installHeader from './config/header';
import installListing from './config/listing';
import installImages from './config/images';
import installSearch from './config/search';
import installFileLinks from './config/fileLinks';

function applyConfig(config: ConfigType) {
  installSettings(config);
  installViews(config);
  installHeader(config);
  installListing(config);
  installImages(config);
  installSearch(config);
  installFileLinks(config);

  return config;
}

export default applyConfig;
